export const iconFontAwesomeUsersPeopleSkull = (
	<i className="fa-solid fa-skull"></i>
);
